<template>

    <div class="col-md-1">

        <div class="row" v-if="authenticatedUser.id!=23">
            <div class="col-md-12">
                <b-link class="" :to="{ path: '/'}">
                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">POS</span> </b-button>
                </b-link>  </div>

        </div>
        <div class="row" v-if="authenticatedUser.id!=23">
            <div class="col-md-12">
                <b-link class="" :to="{ path: '/orders'}">
                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">ORDERS</span> </b-button>
                </b-link>  </div>

        </div>

        <!--                <div class="row">-->
        <!--                    <img class="col-md-12 w-100 mt-3 cursor-pointer" src="@/assets/images/sidebaricons/quotes.png" >-->
        <!--                </div>-->
        <div class="row">
            <div class="col-md-12">
                <b-link class="" :to="{ path: '/products'}">
                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">STOCK CHECK</span> </b-button>
                </b-link>  </div>

        </div>
        <div class="row" v-if="authenticatedUser.id!=23">
            <div class="col-md-12">
                <b-link class="" :to="{ path: '/customers'}">
                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">CUSTOMERS</span> </b-button>
                </b-link>  </div>

        </div>
        <div class="row" v-if="authenticatedUser.id!=23 && !authenticatedUser.permissions.includes('franchise-sales-man')">
            <div class="col-md-12">
                <b-link class="" :to="{ path: '/trade-card' }">
                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">TRADE</span> </b-button>
                </b-link>  </div>

        </div>




<!--        <div class="row">-->
<!--            <div class="col-md-12">-->
<!--                <b-link class="" :to="{ path: '/deliveries'}">-->
<!--                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">DELIVERIES</span> </b-button>-->
<!--                </b-link>  </div>-->

<!--        </div>-->
        <div class="row">
            <div class="col-md-12">
                <b-link class="" :to="{ path: '/dispatch-planner' }">
                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">DISPATCH</span> </b-button>
                </b-link>  </div>

        </div>



        <div class="row" v-if="authenticatedUser.permissions.includes('super')">
            <div class="col-md-12">
                <b-link class="" :to="{ path: '/settings' }">
                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">SETTINGS</span> </b-button>
                </b-link>  </div>

        </div>




<!--        <div class="row">-->
<!--            <div class="col-md-12">-->
<!--                <b-link class="" :to="{ path: '/cash-collections' }">-->
<!--                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">Collections</span> </b-button>-->
<!--                </b-link>  </div>-->

<!--        </div>-->
<!--        <div class="row">-->
<!--            <div class="col-md-12">-->
<!--                <b-link class="" :to="{ path: '/transfer-guide' }">-->
<!--                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">AUTO_TRANS.</span> </b-button>-->
<!--                </b-link>  </div>-->

<!--        </div>-->
        <div class="row">
            <div class="col-md-12" v-if="!authenticatedUser.permissions.includes('franchise-sales-man')">
                <b-link class="" :to="{ path: '/purchase-orders' }">
                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">PURCHASES</span> </b-button>
                </b-link>  </div>

        </div>
        <div class="row">
            <div class="col-md-12">
                <b-link class="" :to="{ path: '/stock' }">
                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections" style="font-size: 11px">
                      <span v-if="!authenticatedUser.permissions.includes('franchise-sales-man')">
                          INTERNAL TRANSFER
                      </span>
                        <span v-else>
                            Stock_Adjustment
                        </span>

                    </span> </b-button>
                </b-link>  </div>

        </div>
        <div class="row" v-if="authenticatedUser.permissions.includes('super')">
            <div class="col-md-12" >

                <b-link class="" :to="{ path: '/reports'}">
                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">REPORTS</span> </b-button>
                </b-link>
            </div>

        </div>
        <div class="row" v-if="!authenticatedUser.permissions.includes('super') && authenticatedUser.id!=23">
            <div class="col-md-12" >

                <b-link class="" :to="{ path: '/branch-reports'}">
                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">REPORTS</span> </b-button>
                </b-link>
            </div>

        </div>
        <div class="row" v-if="!authenticatedUser.permissions.includes('franchise-sales-man')">
            <div class="col-md-12">
                <b-link class="" :to="{ path: '/expenses'}">
                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">EXPENSES</span> </b-button>
                </b-link>  </div>

        </div>

        <div class="row" v-if="!authenticatedUser.permissions.includes('super') && !authenticatedUser.permissions.includes('franchise-sales-man')">
            <div class="col-md-12">
                <b-link class="" :to="{ path: '/tasks'}">
                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">TASKS  <span  v-if="branch_pending_tasks.length>0" class="badge badge-danger">{{ branch_pending_tasks.length }}</span> </span>    <span v-if="branch_pending_tasks.length>0" class="pendingtask-dot"></span></b-button>
                </b-link>

            </div>

        </div>
        <div class="row" >
            <div class="col-md-12">
                <b-link class="" :to="{ path: '/claims'}">
                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  >
                        <span class="collections">CLAIMS
<!--                            <span  v-if="pending_or_approved" class="badge badge-danger">-->
<!--                        {{ branch_pending_tasks.length }}</span>-->
                        </span>    <span v-if="pending_or_approved" class="pendingtask-dot"></span></b-button>
                </b-link>

            </div>

        </div>

<!--        <div class="row">-->
<!--            <div class="col-md-12">-->
<!--                <b-link class="" :to="{ path: '/stock-calculation' }">-->
<!--                    <b-button  type="button" class="btn send w-100 btn-lg  mt-2"  ><span class="collections">Calculation</span> </b-button>-->
<!--                </b-link>  </div>-->

<!--        </div>-->
<!--        <div class="row">-->
<!--            <div class="col-md-12">-->
<!--                <b-link class="" :to="{ path: '/dispatch-planner' }">-->
<!--                    <b-button  type="button" class="btn send w-100 btn-lg  mt-3"  ><span class="collections">Planner</span> </b-button>-->
<!--                </b-link>  </div>-->

<!--        </div>-->









    </div>

</template>

<script>


import {mapActions, mapState} from "vuex";

import apiService from "@/service/apiService";
import Swal from 'sweetalert2'


export default {
    name: "sidebar",
    data() {
        return {
            pending_or_approved:false


        }
    },
    props: {
        generatePdf: { type: Function },
    },

    created () {


    },
   async mounted() {
        await this.check_pending_claim()
    },
    methods: {





        send() {

            this.generatePdf();

        },
        async check_pending_claim(){

            const {data} = await apiService.get(`/check-pending-or-approved-claim`);

          this.pending_or_approved=data.pending_or_approved

        },
    },
    computed:{
        ...mapState('invoice', ['invoice']),
        ...mapState('branch_tasks',['branch_pending_tasks']),

        authenticatedUser() {
            let user = localStorage.getItem('user');
            user=  JSON.parse(user)
            return user
        },
    }

}
</script>

<style scoped>



.pendingtask-dot {
    position: absolute;
    top: 7px;
    left: 124px;
    right: 0px;
    width: 20px;
    height: 20px;
    background-color: red;
    border-radius: 50%;
}


</style>
